import { render, staticRenderFns } from "./MobileGnavButton.vue?vue&type=template&id=4ec10a9a&scoped=true&"
import script from "./MobileGnavButton.vue?vue&type=script&lang=ts&"
export * from "./MobileGnavButton.vue?vue&type=script&lang=ts&"
import style0 from "./MobileGnavButton.vue?vue&type=style&index=0&id=4ec10a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec10a9a",
  null
  
)

export default component.exports